import qs from 'querystring'
import ItemSchema from './Data/Item'
import maybe from './maybe'

const urlName = str => str.toLowerCase().replace(/[^a-z0-9]/gi, '-')

const urlForItem = ({ itemName, itemKey, colour, colourName, size, shoeSizing }) => {
	const myColourName = colourName || (colour && colour.colourName)
	const paramStr = qs.stringify({
		...maybe({ colour: myColourName }, myColourName && !ItemSchema.isSameColourName(myColourName, ItemSchema.allColours)),
		...maybe({ size }, size && size !== ItemSchema.allSizes),
		...maybe({ shoeSizing }, shoeSizing && shoeSizing !== 'undefined')
	})
	return `/item/${itemName ? `${urlName(`${itemName || ''}`)}/` : ''}${itemKey}${paramStr && paramStr !== '' ? `?${paramStr}` : ''}`
}

export default urlForItem



// WEBPACK FOOTER //
// ./src/utilities/urlForItem.js